import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const TemplateSubmissionNote = ({ message }) => {
  return (
    <div className={styles.messageBox}>
      <span className={styles.asteriskIndicator}>*</span>
      <p className={styles.messageText}>{message}</p>
    </div>
  );
};

export default enhance(TemplateSubmissionNote);
